module.exports = __webpack_public_path__ + "static/img/pax.35910a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/pax.png
// module id = SxUj
// module chunks = 0